import { createAuthClient } from "better-auth/react";
import { API_URL } from "./constants";

// API_URL includes /api/v1 suffix, strip it to get the base
const baseURL = API_URL.replace(/\/api\/v1$/, "");

export const authClient = createAuthClient({
  baseURL,
  basePath: "/api/v1/auth",
  fetchOptions: {
    credentials: "include",
  },
});

export const { useSession, signIn, signUp, signOut } = authClient;
